function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 192 192",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M56 30c0-1.662 1.338-3 3-3h108c1.662 0 3 1.338 3 3v132c0 1.662-1.338 3-3 3H59c-1.662 0-3-1.338-3-3v-32m0-68V30",
    style: {
      fillOpacity: 0.402658,
      stroke: "currentColor",
      strokeWidth: 12,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    x: -58.1,
    y: 40.3,
    rx: 3,
    style: {
      fill: "none",
      fillOpacity: 0.402658,
      stroke: "currentColor",
      strokeWidth: 12,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    },
    transform: "translate(80.1 21.7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.79 164.725V27.175M56.175 58.792H170M170 96H90.328M169 133.21H56.175M44.5 82l23 28m0-28-23 28",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 12,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.e54c8d111c6851e622cbf8878b88e2cd.svg";
export { ForwardRef as ReactComponent };